import React from 'react'
import { Link as GatsbyLink } from 'gatsby'

type LinkProps = {
  to: string
  className?: string
  children?: React.ReactNode
  title?: string
}

const Link: React.FC<LinkProps> = ({
  to,
  className = undefined,
  children = undefined,
  title = undefined,
}) => {
  if (to.startsWith('https://')) {
    return (
      <a href={to} className={className} title={title}>
        {children}
      </a>
    )
  }
  return (
    <GatsbyLink to={to} className={className} title={title}>
      {children}
    </GatsbyLink>
  )
}

export default Link
